import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import ExpansionPanel from "@material-ui/core/ExpansionPanel"
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary"
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails"
import Typography from "@material-ui/core/Typography"
import { RichDescription, RichTitle } from ".."
import plus from "./plus.svg"
import less from "./less.svg"

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    minHeight: theme.spacing(7.5),
  },
  heading: {
    position: "relative",
    bottom: theme.spacing(0.5),
    color: theme.palette.green.border,
    fontWeight: "bold",
  },
  expandedHeader: {
    position: "relative",
    bottom: theme.spacing(0.5),
    color: theme.palette.black.border,
    fontWeight: "bold",
  },
  expansionPanel: {
    boxShadow: "none",
    backgroundColor: "#fafafa",
  },
  divider: {
    margin: "0px",
    boxShadow: "none",
    marginLeft: theme.spacing(3),
    borderTop: "0.5px solid #C3C5C8",
  },
  plusSign: {
    position: "relative",
    bottom: theme.spacing(0.5),
  },
  lessSign: {
    position: "relative",
  },
  content: {
    width: "100%",
    maxWidth: theme.spacing(90),
    textAlign: "left",
    position: "relative",
    overflowWrap: "break-word",
  },
}))

const Accordion = props => {
  const classes = useStyles()
  const [open, setOpen] = React.useState(false)
  const handleChange = panel => (event, newExpanded) => {
    setOpen(!open)
  }

  return (
    <div className={classes.root}>
      <ExpansionPanel
        className={
          props.expansionPanel ? props.expansionPanel : classes.expansionPanel
        }
        oexpanded={`${open}`}
        onChange={handleChange()}
      >
        <ExpansionPanelSummary
          expandIcon={
            !open ? (
              <img className={classes.plusSign} src={plus} alt="" />
            ) : (
              <img className={classes.lessImg} src={less} alt="" />
            )
          }
        >
          <Typography
            className={!open ? classes.heading : classes.expandedHeader}
            variant={"caption"}
          >
            {props.question && (
              <RichTitle faq open={open} titleText={props.question} />
            )}
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography className={classes.content}>
            {props.answer && <RichDescription copyText={props.answer} />}
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>
      <hr className={classes.divider} />
    </div>
  )
}

export default Accordion
